/**
 * Authenticated share-link enrollment.
 *
 * Joiners who open /apps/session/:id (or participate) must land on the session
 * roster — presence alone is not enough. Calls enroll_self_in_session (662).
 */

import { getSafeSupabaseClient } from './supabaseSync';

export async function enrollSelfInSession(
  sessionId: string,
): Promise<{ success: boolean; enrolled?: boolean; error?: string }> {
  const supabase = getSafeSupabaseClient();
  if (!supabase) return { success: false, error: 'Not connected' };

  const { data, error } = await supabase.rpc('enroll_self_in_session', {
    p_session_id: sessionId,
  });

  if (error) {
    console.warn('[enrollSelfInSession]', error.message);
    return { success: false, error: error.message };
  }

  const payload = (data ?? {}) as { success?: boolean; enrolled?: boolean };
  return {
    success: payload.success !== false,
    enrolled: payload.enrolled,
  };
}
